<template>
  <div class="card shadow-sm border-0 rounded-4 h-100">
    <div class="card-body p-3">
      <div class="d-flex justify-content-between flex-column align-items-start mb-1">
        <h6 class="text-uppercase text-muted fs-6 mb-0">Ingresos Mensuales</h6>
        <span class="badge rounded-pill px-3 py-1" :class="badgeClass">{{ label }}</span>
      </div>

      <h5 class="fw-semibold fs-5 mb-1">{{ currency }} {{ formatNumber(amount) }}</h5>
      <small class="text-muted">Puntos: <strong>{{ computedPoints.toFixed(1) }}</strong> (0–25)</small>
    </div>
  </div>
</template>

<script>
export default {
  name: "IncomeCard",
  props: {
    amount: { type: Number, default: null },
    currency: { type: String, default: "Lps" },
    // v-model:points => aporte a score total
    points: { type: Number, default: 0 },
    // Tope superior de la última banda (>35000) para alcanzar 25 pts
    topBandMax: { type: Number, default: 50000 }
  },
  computed: {
    computedPoints() {
      const a = Number(this.amount);
      if (!Number.isFinite(a) || a < 0) return 0;

      // 0–4 -> <12499  (mapeo lineal 0..12499 → 0..4)
      if (a < 12500) return this.mapClamp(a, 0, 12499, 0, 4);

      // 5–9 -> 12500–14999
      if (a <= 14999) return this.mapClamp(a, 12500, 14999, 5, 9);

      // 10–14 -> 15000–24999
      if (a <= 24999) return this.mapClamp(a, 15000, 24999, 10, 14);

      // 15–19 -> 25000–34999
      if (a <= 34999) return this.mapClamp(a, 25000, 34999, 15, 19);

      // 20–25 -> >35000 (usamos 35000..topBandMax → 20..25, y clamp > topBandMax a 25)
      const hi = Math.max(this.topBandMax, 35000 + 1);
      return this.mapClamp(Math.min(a, hi), 35000, hi, 20, 25);
    },

    // Etiqueta sencilla por banda (opcional)
    label() {
      const p = this.computedPoints;
      if (p >= 20) return "Ingresos Muy Altos";
      if (p >= 15) return "Ingresos Altos";
      if (p >= 10) return "Ingresos Medios";
      if (p >= 5)  return "Ingresos Bajos";
      return "Ingresos Muy Bajos";
    },
    badgeClass() {
      const p = this.computedPoints;
      if (p >= 20) return "bg-success-subtle text-success-emphasis";
      if (p >= 10) return "bg-warning-subtle text-warning-emphasis";
      return "bg-danger-subtle text-danger-emphasis";
    }
  },
  watch: {
    computedPoints: {
      immediate: true,
      handler(val) {
        this.$emit("update:points", Number(val.toFixed(1)));
      }
    }
  },
  methods: {
    formatNumber(v) {
      if (v === null || v === undefined || v === "") return "—";
      const n = Number(v);
      if (Number.isNaN(n)) return String(v);
      return n.toLocaleString("es-ES", { maximumFractionDigits: 2 });
    },
    mapClamp(x, inMin, inMax, outMin, outMax) {
      const clamped = Math.min(Math.max(x, inMin), inMax);
      const ratio = (clamped - inMin) / (inMax - inMin || 1);
      return outMin + ratio * (outMax - outMin);
    }
  }
};
</script>

<style scoped>
.bg-success-subtle { background-color: rgba(25,135,84,.12) !important; }
.text-success-emphasis { color: #146c43 !important; }
.bg-warning-subtle { background-color: rgba(255,193,7,.15) !important; }
.text-warning-emphasis { color: #997404 !important; }
.bg-danger-subtle { background-color: rgba(220,53,69,.12) !important; }
.text-danger-emphasis { color: #842029 !important; }
</style>
